export default __webpack_public_path__ + "static/media/computer.b27db82f.jpg";